export const getMarkers = input => (!input.value ? '' : input.value);

export const getPosition = (e) => ({
  lng: e.latLng.lng(),
  lat: e.latLng.lat(),
});
